import React from "react";

const NotFound = () => {
  return (
    <div className="w-[100vw] h-[100vh] flex justify-center items-center">
      <h1 className="text-red-500">NOT FOUND</h1>
    </div>
  );
};

export default NotFound;
